<template>
  <BTable
    v-bind="$attrs"
    :selected="value"
    :headers="headers"
    :actions="actions"
    :list="list"
    :item-class="getRowClass"
    v-on="$listeners || {}"
  >
    <!--  -->

    <template #item.type_label="{ value: v }">
      <v-tooltip top>
        <template #activator="{ attrs, on }">
          <v-icon
            v-bind="attrs"
            :style="{ color: v.icon.color }"
            v-on="on"
            v-text="v.icon.name"
          />
        </template>
        <div v-text="v.label" />
      </v-tooltip>
    </template>

    <template #item.type="{ value: v }">
      <span
        v-if="v.status"
        :style="{ color: v.status.color }"
        v-text="v.status.name"
      />

      <span v-if="v.date" v-text="v.date.name" />

      <a
        v-if="v.file"
        :href="v.file.url"
        target="__blank"
        v-text="v.file.name"
      />
    </template>

    <template #item.user="{ value: v, header }">
      <v-tooltip v-if="v" top>
        <template #activator="{ attrs, on }">
          <div v-bind="attrs" v-on="on">
            <router-link :to="header.getRoute(v)" v-text="v.username" />
          </div>
        </template>
        <div style="max-width: 300px;" v-text="v.full_name" />
      </v-tooltip>
    </template>

    <!--  -->
  </BTable>
</template>

<script>
import {
  getRoadmapEventStatusesColor,
  getRoadmapHistoryEventStatusesLabel,
} from '@/typings/api/RoadmapEvent'
import variables from '@/assets/scss/exports.scss'
import { dateFormatter } from '@/helpers/dateFormatter'
import { USERS_ROUTES } from '@/views/Users/utils'

import BTableSimple from './BTableSimple.vue'

const TYPES = {
  STATUS: 'status',
  FILE_ADDED: 'file_added',
  FILE_DELETED: 'file_deleted',
  DATE_CHANGED: 'date_changed',
}

const getIconSettingsByType = (data) => {
  const { type, status } = data

  switch (type) {
    case TYPES.STATUS:
      return {
        name: 'mdi-alert-circle',
        color: getRoadmapEventStatusesColor(status),
      }

    case TYPES.FILE_ADDED:
      return {
        name: 'mdi-plus-circle',
        color: variables['webflow-color-green'],
      }

    case TYPES.FILE_DELETED:
      return {
        name: 'mdi-close-circle',
        color: variables['webflow-color-red'],
      }

    case TYPES.DATE_CHANGED:
      return {
        name: 'mdi-calendar-month-outline',
      }

    default:
      return {
        name: 'mdi-help-circle',
      }
  }
}

const getTypeSettings = (type, data) => {
  switch (type) {
    case TYPES.STATUS:
      return {
        status: {
          name: getRoadmapHistoryEventStatusesLabel(data.status),
          // color: getRoadmapEventStatusesColor(data.status),
        },
      }

    case TYPES.FILE_ADDED:
    case TYPES.FILE_DELETED: {
      const { file } = data
      return {
        file: {
          name: file?.name,
          url: file?.raw_file?.url,
        },
      }
    }

    case TYPES.DATE_CHANGED:
      return {
        date: {
          name: data.description,
        },
      }

    default:
      return ''
  }
}

const TABLE_HEADERS = [
  {
    text: 'Тип',
    value: 'type_label',
    field: (label, data) => ({
      label,
      icon: getIconSettingsByType(data),
      color:
        data.type === TYPES.STATUS
          ? getRoadmapEventStatusesColor(data.status)
          : null,
    }),
    sortable: false,
    width: 40,
  },
  {
    text: '',
    sortable: false,
    value: 'type',
    field: getTypeSettings,
  },
  {
    text: 'Пользователь',
    value: 'user',
    sortable: false,
    width: 160,
    getRoute: (data) => ({
      name: USERS_ROUTES.VIEW,
      params: { id: data.id },
    }),
  },
  {
    text: 'Дата изменения',
    value: 'created_at',
    sortable: false,
    width: 150,
    field: (value) => value && dateFormatter(value),
  },
]

export default {
  name: 'BTableEventHistory',
  extends: BTableSimple,
  props: {
    value: Array,
    headers: {
      type: Array,
      default: () => TABLE_HEADERS,
    },
    actions: {
      type: Array,
      default: () => [],
    },
  },
  methods: {
    getRowClass({ is_unread }) {
      return is_unread ? 'event-table-history__row_unread' : ''
    },
  },
}
</script>

<style lang="scss">
$background-color: rgba(74, 117, 157, 0.15);

.event-table-history__row_unread {
  background: $background-color;
}
</style>
